export default {
  Facebook: {
    icon: 'social-facebook',
    displayName: 'Facebook',
  },
  Google: {
    icon: 'social-google',
    displayName: 'Google My Business',
  },
  Twitter: {
    icon: 'social-x',
    displayName: 'X',
    subText: '(Twitter)',
  },
  Instagram: {
    icon: 'social-instagram',
    displayName: 'Instagram',
  },
  LinkedIn: {
    icon: 'social-linkedin',
    displayName: 'LinkedIn',
  },
  Pinterest: {
    icon: 'social-pinterest',
    displayName: 'Pinterest',
  },
  Wordpress: {
    icon: 'wordpress',
    displayName: 'Wordpress',
  },
  Yelp: {
    icon: 'social-yelp',
    displayName: 'Yelp',
  },
  YouTube: {
    icon: 'social-youtube',
    displayName: 'Youtube',
  },
};
